import { type FunctionComponent } from 'react';

export type ModelProps = {
	modelNumber: string;
	fontSize?: 'f6' | 'f7';
	truncate?: boolean;
	className?: string;
};

export const Model: FunctionComponent<ModelProps> = ({ modelNumber, fontSize = 'f6', truncate = true, className = '' }) => {
	return <div className={`lh-title theme-grey ${fontSize} ${truncate ? 'truncate' : ''} ${className}`}>Model: {modelNumber}</div>;
};
